import { memo as Memo, useMemo, useState } from 'react'
import { useRouter } from 'next/router'

//* HOC
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Components
import Icon from 'components/common/Icon'
import Text from 'components/common/Text'
import CustomLink from 'components/common/CustomLink'

//* Styles
import ShareLinkStyle from './style'

const ShareLink = Memo((props) => {
	//! Router
	const router = useRouter()

	//! State
	const [isCopied, setIsCopied] = useState(false)

	//! Copy url function
	const copyUrl = () => {
		const el = document.createElement('input')
		el.value = window.location.href
		document.body.appendChild(el)
		el.select()
		document.execCommand('copy')
		document.body.removeChild(el)
	}

	const handleCopyLinkClick = () => {
		copyUrl()
		setIsCopied(true)

		setTimeout(() => {
			setIsCopied(false)
		}, 1500)
	}

	const url = useMemo(() => process.env.host + router.asPath, [router])

	const facebookUrl = useMemo(() => `https://www.facebook.com/sharer/sharer.php?u=${url}`, [url])
	const twitterUrl = useMemo(() => `https://twitter.com/intent/tweet?url=${url}`, [url])

	return (
		<ShareLinkStyle className={`share-links-wrap`}>
			{props.winWidth > 768 ? (
				<>
					<Text
						tag={`p`}
						className={`p p3 notoSans-medium primary-color9`}
						text={`shareWithSymbol`}
					/>

					<CustomLink
						url={facebookUrl}
						target={'_blank'}
						ariaLabel={'facebook'}
						rel={'noopener noreferrer'}
						className={`share-item`}
						content={
							<Icon
								name={`facebook`}
								className={`share-icon`}
							/>
						}
					/>

					<CustomLink
						url={twitterUrl}
						target={'_blank'}
						ariaLabel={'twitter'}
						className={`share-item`}
						rel={'noopener noreferrer'}
						content={
							<Icon
								name={`twitter`}
								className={`share-icon`}
							/>
						}
					/>

					<div
						className={`share-item cursor-pointer`}
						onClick={handleCopyLinkClick}
					>
						<Icon
							name={`copy`}
							className={`share-icon`}
						/>
					</div>
				</>
			) : (
				<div className={`mobile-wrapper`}>
					<Text
						tag={`p`}
						className={`p p3 notoSans-medium primary-color9 align-center`}
						text={`shareWithSymbol`}
					/>

					<div className={`icons-wrap`}>
						<CustomLink
							url={facebookUrl}
							target={'_blank'}
							ariaLabel={'facebook'}
							rel={'noopener noreferrer'}
							className={`share-item`}
							content={
								<Icon
									name={`facebook`}
									className={`share-icon`}
								/>
							}
						/>

						<CustomLink
							url={twitterUrl}
							target={'_blank'}
							ariaLabel={'twitter'}
							className={`share-item`}
							rel={'noopener noreferrer'}
							content={
								<Icon
									name={`twitter`}
									className={`share-icon`}
								/>
							}
						/>

						<div
							className={`share-item cursor-pointer`}
							onClick={handleCopyLinkClick}
						>
							<Icon
								name={`copy`}
								className={`share-icon`}
							/>
						</div>
					</div>
				</div>
			)}

			{isCopied && (
				<Text
					tag={`p`}
					className={`p p4 notoSans-medium primary-color1 copy-text`}
					text={`copied`}
				/>
			)}
		</ShareLinkStyle>
	)
})

export default withUIContext(ShareLink, ['winWidth'])
